import React, { useState } from 'react';
import { pollsAnswerFormatted, sortAlphabetically, attachRightAnswerMarkerIfNeeded } from '../../helper/commonUtils';

const PollAnswerBlock = ({ ans = [], rightAns = [], questionType = '' }) => {
  const [expanded, setExpanded] = useState(false);

  const markedAnswer = attachRightAnswerMarkerIfNeeded({ rightAnswers: rightAns, answer: ans.answer, questionType });

  return (
    <div className="vve-poll-option-block">
      <div className="vve-poll-option-text">
        <span>{pollsAnswerFormatted(ans.answer)}</span>
        {markedAnswer && <span className="vve-tick-icon"></span>}
        <span className="vve-poll-option-percentage">{ans.percentage}%</span>
      </div>
      <div className="vve-poll-responses-toggle" onClick={() => setExpanded(prev => !prev)}>
        <span className={`vve-poll-toggle-icon ${expanded ? 'vve-polls-up-arrow-icon' : 'vve-polls-down-arrow-icon'}`}></span>
        <span className="vve-poll-responses-count">
          {ans.votes} {ans.votes === 1 ? 'response' : 'responses'}
        </span>
      </div>
      {expanded && (
        <div className="vve-poll-participants-list">
          {sortAlphabetically(ans.names).map(name => (
            <span>{name}</span>
          ))}
        </div>
      )}
    </div>
  );
};

export default PollAnswerBlock;
